import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AddOrderFormValues } from "../../Interfaces/callOptionsInterfaces";

export interface CoveredCallSliceState {
  addOrderFormValues: AddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
}

const initialState: CoveredCallSliceState = {
  addOrderFormValues: null,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
};

const CoveredOrderSlice = createSlice({
  name: "coveredOrder",
  initialState,
  reducers: {
    setAddCoveredOrderFormValues: (
      store,
      action: PayloadAction<AddOrderFormValues>,
    ) => {
      if (store.addOrderFormValues !== action.payload)
        store.addOrderFormValues = action.payload;
    },
    setCoveredOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setCoveredTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
  },
});

export const {
  setAddCoveredOrderFormValues,
  setCoveredOrderTableFetchDataFlag,
  setCoveredTradeTableFetchDataFlag,
} = CoveredOrderSlice.actions;
export default CoveredOrderSlice.reducer;
